import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Trans } from "@lingui/macro";

import { Button } from "components/UI/Button/Button";

import { Loader } from "components/UI/Loader/Loader";
import { IdOrdersState } from "model/dashboardOrders/dOrdersReducer";
import { notEditedStatus, ORDERSTATUS } from "constants/ordersStatus";

import { dOrdersChangeStatusBulkSagaAC } from "model/dashboardOrders/dOrdersActionCreators";
import { Alert } from "components/UI/Alert/Alert";

// Type
export type typePopupEdit = {
  variant?: string;
  setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
};

// Component
export const PopupBulkCancel: React.FC<typePopupEdit> = ({
  variant,
  setOpenPopup,
}) => {
  const dispatch = useDispatch();

  // System

  const filters = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.filters,
  );
  const pagination = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.pagination,
  );

  const dataList = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.data,
  );

  // Form data

  const selectedOrders = dataList.filter(
    (item) => item.checked && item.status !== ORDERSTATUS.COMPLETE,
  );

  const [loader, setLoader] = useState(false);

  const onSaveHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoader(true);

    const data = selectedOrders
      .filter((order) => !notEditedStatus.includes(order.status))
      .map((item) => {
        return {
          id: item.id,
          status: ORDERSTATUS.CANCEL,
        };
      });

    if (data.length > 0) {
      dispatch(
        dOrdersChangeStatusBulkSagaAC(data, filters, {
          page: pagination.pageNumber,
          size: pagination.itemsPerPage!,
        }),
      );
    }
    setLoader(false);
    setOpenPopup(false);
  };

  return (
    <>
      <>
        <form className="">
          <Alert
            type={"info"}
            title={
              <Trans>
                For orders with the status "Delivered", "Complete" or
                "Cancel",the changes will not be applied.
              </Trans>
            }
          />

          <div className="Flex flex-wrap  gap-4 p-4">
            <Trans>You are canceling orders</Trans>:{" "}
            {selectedOrders.map((order, i) => {
              return (
                <span key={order.number}>
                  {order?.number}
                  {i === selectedOrders.length - 1 ? "" : ", "}{" "}
                </span>
              );
            })}
          </div>

          <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <Button
              type="submit"
              variant={variant}
              disabled={loader}
              label={<Trans>Yes, cancel</Trans>}
              onClick={(e) => onSaveHandler(e)}
            />
            <Button
              type="button"
              variant={variant}
              secondary={true}
              label={<Trans>No, don't cancel</Trans>}
              onClick={() => setOpenPopup(false)}
            />
          </div>
          {loader ? <Loader variant="support" /> : null}
        </form>
      </>
    </>
  );
};
